require('./card-account.component.scss');

class CardAccountController {
  constructor(
    $scope,
    CurrentFilterService,
    PermissionService,
    LayoutService,
    RouterService,
  ) {
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.keysFilter = ['agent_account.guid', 'agent_account.id', 'agent_agent.guid', 'agent_agent.id'];
    $scope.addScreenshot = () => {
      this.router.drilldownFilter('agent_eventtype@default:agent_eventtype', '4', gettext('Снимок экрана'));
      this.router.mode = 'explore';
    };
  }
}

export const CardAccountComponent = {
  template: require('./card-account.component.html'),
  bindings: {
    filter: '<',
    card  : '<',
  },
  controller: CardAccountController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/card-account.component.js